var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75ZM8.93182 5.61585C7.94464 5.61585 7.46591 6.4014 7.46591 7.04268C7.46591 7.14371 7.38959 7.22561 7.29545 7.22561C7.20131 7.22561 7.125 7.14371 7.125 7.04268C7.125 6.22055 7.73718 5.25 8.93182 5.25C9.79988 5.25 10.3013 5.60402 10.5755 6.06447C10.8409 6.51022 10.875 7.02589 10.875 7.32206C10.875 7.76816 10.7518 8.1014 10.5631 8.36711C10.3788 8.62667 10.1365 8.81472 9.91521 8.97911L9.86763 9.01441C9.4289 9.3397 9.10227 9.58187 9.10227 10.1159V11.14C9.10227 11.241 9.02596 11.3232 8.93182 11.3232C8.83768 11.3232 8.76136 11.2413 8.76136 11.1402V10.1159C8.76136 9.38461 9.2357 9.03564 9.64482 8.73466L9.72116 8.67831C9.94307 8.51344 10.1439 8.35393 10.292 8.14537C10.4357 7.94295 10.5341 7.6875 10.5341 7.32206C10.5341 7.04618 10.5 6.61728 10.2882 6.26147C10.0851 5.92037 9.70012 5.61585 8.93182 5.61585ZM8.93181 12.75C9.08243 12.75 9.20454 12.619 9.20454 12.4573C9.20454 12.2957 9.08243 12.1646 8.93181 12.1646C8.78119 12.1646 8.65908 12.2957 8.65908 12.4573C8.65908 12.619 8.78119 12.75 8.93181 12.75Z",
    fill: "#555555"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.d022e204.svg";
export { ForwardRef as ReactComponent };